import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { WIZ_EVENT_TYPE, VALUE_ENTER, WizMathUtils } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizFocusManager,
  WizTextInput,
  WizTranslationBasic,
  WizValidationContainerDirective,
  WizValidationErrors,
  WizValidatorFn,
  WizValidationError,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { Model } from 'src/app/model/model';
import { PhysicalTemplateVO, TabVO, ViewData } from '@wizeoo/akm-common-lib';

@Component({
  selector: 'new-tab-pop',
  templateUrl: './new-tab.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewTabPop extends WizBasePopUp {
  @ViewChild(WizValidationContainerDirective, { read: WizValidationContainerDirective })
  private validationContainer: WizValidationContainerDirective;

  @ViewChild('tiCode', { read: WizTextInput, static: true }) tiCode: WizTextInput;
  @ViewChild('tiLabel', { read: WizTranslationBasic, static: true }) tiLabel: WizTranslationBasic;
  @ViewChild('tiDescription', { read: WizTranslationBasic, static: true }) tiDescription: WizTranslationBasic;

  private _tab: TabVO = new TabVO(Model.getInstance());

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
    super();
  }

  private _isValidable: boolean = false;
  public get isValidable(): boolean {
    // activation du bouton de sauvegarde
    return this._isValidable;
  }

  // validation sur enter
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER && this.isValidable) {
      this.validate();
    }
  }

  show() {
    const template: PhysicalTemplateVO = this.datas.template;
    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;
    this._tab.visionCode = template.visionCode;
    // this._tab.widgets = template.widgets;
    this._tab.physTempCode = template.code;

    this.tiLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this._tab.labelVO);
    this.tiDescription.translationData = Model.getInstance().localeEngine.buildTranslationData(this._tab.descriptionVO);

    // focus du premier champ
    if (this.tiCode) {
      WizFocusManager.getInstance().wizSetFocus(this.tiCode);
    }

    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.onModelUpdate);
  }

  onModelUpdate(e: WizEvent): void {
    const errors: WizValidationErrors = this.validationContainer.check(true);
    this._isValidable = !!errors || errors.length === 0;
    this.cdref.markForCheck();
  }

  validate(): void {
    this._tab.code = this.tiCode.wizValue?.toUpperCase();
    this._tab.domain = Model.getInstance().domainCode;
    this._tab.businessUnitCode = Model.getInstance().businessUnitCode;
    this._tab.uid = WizMathUtils.createUUID();
    this._tab.owner = Model.getInstance().connectedUser.mail;
    this._tab.visionCode = Model.getInstance().visionCode;

    this.tiLabel.entryDS.getSource().forEach((entry) => this._tab.labelVO.updateTranslationEntry(entry));
    this.tiDescription.entryDS.getSource().forEach((entry) => this._tab.descriptionVO.updateTranslationEntry(entry));

    const errors: WizValidationErrors = this.validationContainer.check(false);
    this._isValidable = !errors || errors.length === 0;
    if (this._isValidable) {
      Model.getInstance().tabEngine.merge(this._tab, null, this.onTabMerged.bind(this));
    }
  }


  /** Validateur d'unicité du code principal */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le currentChronocode est null
      if (this._tab === null || this._tab === undefined) {
        return null;
      }
      if (
        this.tiCode.wizValue !== null &&
        this.tiCode.wizValue &&
        this.tiCode.wizValue.length > 0
      ) {
        // Recherche d'un autre pays avec le même code
        let feat: string = Model.getInstance().visionCode + ViewData.KEY_SEPARATOR + this.tiCode.wizValue.toUpperCase();
        const otherTab = Model.getInstance().tabEngine.getTabByCode(feat);

        // Si un chro existe deja avec le meme code on affiche le message
        if (!!otherTab) {
          const temp: WizValidationError = {
            wizError: '$.tab.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }


  onTabMerged(tab: TabVO, status: string) {
    if (!!this.callback) {
      this.callback(tab);
    }
    this.hide();
  }

  hide() {
    WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE);
    super.hide();
  }
}
